import Cookies from 'js-cookie';

export function getSelectedLanguage() {
    return Cookies.get('language.code.selection') || 'en';
}
